<template>
    <div class="row filter-functions-desktop">
        <div>
            <div class="col-xs-3 text-right label-fixed-width">
                <label>Filters:</label>
            </div>

            <div class="col-xs-9 filter-form-row">
                <div class="form-inline">
                    <span class="date-picker-wrapper">
                        <datepicker v-model="options.startDate" :calendar-button="true" calendar-button-icon="fa fa-calendar"
                                    :clear-button="true" clear-button-icon="fa fa-times" :bootstrap-styling="true"
                                    format="yyyy MMM dd" @input="changed" :typeable="true"></datepicker>
                    </span>
                    <span class="to-label">to</span>
                    <span class="date-picker-wrapper last">
                        <datepicker v-model="options.endDate" :calendar-button="true" calendar-button-icon="fa fa-calendar"
                                    :clear-button="true" clear-button-icon="fa fa-times" :bootstrap-styling="true"
                                    format="yyyy MMM dd" @input="changed" :typeable="true"></datepicker>
                    </span>
                    <span class="reverese-clerical-toggles">
                        <label>
                            <input type="checkbox" v-model="options.showReversed" @change="changed" />
                            Show reversed
                        </label>
                        <label>
                            <input type="checkbox" v-model="options.showClerical" @change="changed" />
                            Show clerical
                        </label>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import Datepicker from 'vuejs-datepicker';

    Vue.component("datepicker", Datepicker);

    export default {
        data: function () {
            return {
                options: this.$store.state.searchFilter
            };
        },
        methods: {
            changed() {
                this.$emit('change');
            }
        }
    };
</script>